import { apiClient, handleRequest } from '@/shared/api';
import type {
  SendMfaOtpCodeRequestDto,
  SendMfaOtpCodeResponseDto,
  TwoFactorIdentitiesDto,
} from './types';
import { normalizeIdentityType } from '../lib';
import type { MFAIdentityType } from '@/entities/mfa-identity';

export const getTwoFactorIdentities = async () => {
  const request = () => apiClient.get('/security/twofa');
  const response = await handleRequest<TwoFactorIdentitiesDto>(request);
  return response.data.map(identity => ({
    ...identity,
    identityTypeName: normalizeIdentityType(
      identity.identityTypeName
    ) as MFAIdentityType,
  }));
};

export const sendTwoFactorIdentityCode = async (
  args: SendMfaOtpCodeRequestDto
) => {
  const request = () => apiClient.post(`/security/otp/send`, args);
  const response = await handleRequest<SendMfaOtpCodeResponseDto>(request);
  return response.data;
};
